// filepath: /Users/dylan/Respositories/bhpr-web/src/views/TrialActivatedConfirmation.js
import React, { useEffect, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import styled from "styled-components";
import { Button } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"; // Example success icon
import { THEME_MAP } from "../theme";
import dayjs from "dayjs";

// Re-use styling similar to VerifyPromotionPayment if desired
const Container = styled.div`
    height: 100%;
    width: 100%;
    padding: 24px;
    overflow: auto;
`;

const ConfirmationContainer = styled.div`
    max-width: 800px;
    margin: auto;
    background: ${THEME_MAP["color-basic-100"]};
    border-radius: 4px;
    border: 1px solid ${THEME_MAP["color-basic-400"]};
    min-height: 300px;
    padding: 32px;
    margin-bottom: 16px;
    text-align: center;
`;

const IconContainer = styled.div`
    margin-top: 30px;
    margin-bottom: 20px;
    color: ${THEME_MAP["color-success-500"]}; // Success color
    svg {
        font-size: 4rem;
    }
`;

 const MessagesContainer = styled.div`
    margin-bottom: 40px;
    h2 {
        margin-bottom: 15px;
    }
    p {
        color: ${THEME_MAP["color-basic-700"]};
        line-height: 1.5;
    }
`;

const ButtonContainer = styled.div`
    margin-top: 30px;
`;

export const TrialActivatedConfirmation = () => {
    const history = useHistory();
    const { barId, promotionId } = useParams(); // Get IDs from URL
    const location = useLocation(); // Get state passed during navigation
    const trialEndDate = location.state?.trialEndDate; // Get trial end date from state

    const [formattedEndDate, setFormattedEndDate] = useState("");

    useEffect(() => {
        if (trialEndDate) {
            setFormattedEndDate(dayjs(trialEndDate).format("MMMM D, YYYY"));
        }
        // Optional: Fetch promotion details using promotionId if needed to display name
    }, [trialEndDate, promotionId]);

    const goToPromotions = () => {
        if (barId) {
            history.push(`/promotions/${barId}`); // Navigate to bar's promotions list
        } else {
            history.push("/promotions"); // Fallback
        }
    };

    return (
        <Container>
            <ConfirmationContainer>
                <IconContainer>
                    <CheckCircleOutlineIcon />
                </IconContainer>
                <MessagesContainer>
                    <h2>Free Trial Activated!</h2>
                    <p>
                        Your 90-day free trial for promoting has started.
                        The promotion you selected has been activated.
                    </p>
                    {formattedEndDate && (
                         <p>Your free trial period ends on <strong>{formattedEndDate}</strong>.</p>
                    )}
                     <p>You can manage this promotion and create others from the promotions page.</p>
                </MessagesContainer>
                <ButtonContainer>
                    <Button
                        onClick={goToPromotions}
                        variant="contained"
                        color="primary"
                    >
                        View Promotions
                    </Button>
                </ButtonContainer>
            </ConfirmationContainer>
        </Container>
    );
};